export const PLACEHOLDER_PASSWORD = 'placeholder password'
